<template>
    <div class="min-height">
        <p class="notice-msg">敬请期待</p>
    </div>
</template>

<script>
    export default {
        name: "TaskInfo"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/fragment/MemberManage/TaskInfo.vue